var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 1.417V14.583C1.375 15.3653 2.00978 16 2.79297 16H3.5V0H2.79297C2.00978 0 1.375 0.634781 1.375 1.417Z",
    fill: "#B0B4C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.207 0H4.25V16H13.207C13.9902 16 14.625 15.3653 14.625 14.583V1.417C14.625 0.634781 13.9902 0 13.207 0ZM9.17578 11.3477H6.22753L6.28809 10.5625C6.34278 10.2642 6.53906 10.0108 6.81447 9.88475L8 9.39991C8.19728 9.30909 8.32422 9.11134 8.32422 8.89356V8.71925C8.32422 8.63672 8.31053 8.55469 8.28419 8.47656C8.28419 8.47656 7.53809 7.48144 7.53809 6.56397C7.53809 5.417 8.2715 4.67969 9.17578 4.67969C10.0811 4.67969 10.8145 5.417 10.8145 6.56397C10.8145 7.48144 10.0684 8.47656 10.0684 8.47656C10.041 8.55469 10.0283 8.63672 10.0283 8.71925V8.89356C10.0283 9.11134 10.1543 9.30909 10.3526 9.39991L11.5381 9.88478C11.8135 10.0107 12.0098 10.2642 12.0645 10.5625L12.125 11.3477H9.17578Z",
    fill: "#B0B4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectory);
export default __webpack_public_path__ + "static/media/directory.3dc450edde1e5df973927407c9dee01e.svg";
export { ForwardRef as ReactComponent };